import { useEffect, useState } from "react"
import ContainerLayout from "./containerlayout"
import Accordion from "../campusLife/accordion"

import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../utils/decodeHtml"

const ProfessionalAndExecutiveEducation = ({ admission }) => {


    const header4 = admission?.header4
    const description4 = admission?.description4

    const [accordion, setAccordion] = useState([])

    useEffect(() => {
        setAccordion(
            admission?.accordions1?.items?.map(item => {
                item = item?.content?.properties
                return ({
                    question: item?.label,
                    answer: DecodeHtml({ html: item?.accordionContent?.markup }),
                    open: false
                }
                )
            })
        )
    }, [admission?.accordions1?.items])


    return (
        <ContainerLayout>
            <h1 className="w-auto   text-4xl font-bold ">{header4}</h1>
            <p className=" text-justify text-slate-500">{description4}</p>

            <div className="max-w-5xl">
                <Accordion accordion={accordion} setAccordion={setAccordion} />
            </div>

        </ContainerLayout>
    )
}
ProfessionalAndExecutiveEducation.propTypes = {
    admission: PropTypes.object
}
export default ProfessionalAndExecutiveEducation